<template>
  <a-layout class="ant-layout">
    <a-layout-header class="main-header">
      <a-menu mode="horizontal" class="menu">
        <a-sub-menu key="sub00">
          <template #icon>
            <a-avatar style="box-shadow: -5px 1px 5px #fff">
              <template #icon>
                <img
                  src="https://t7.baidu.com/it/u=4162611394,4275913936&fm=193&f=GIF"
                />
              </template>
            </a-avatar>
          </template>
          <template #title>欢迎您:{{ loginData.name }}</template>
          <a-menu-item key="/mineDepartmentOverview"
            ><router-link to="/mineDepartmentOverview">{{
              loginData.username
            }}</router-link></a-menu-item
          >

          <a-menu-item key="/mineCenter"
            ><router-link to="/mineCenter">个人中心</router-link></a-menu-item
          >
          <a-menu-item key="/editPassword"
            ><router-link to="/editPassword">修改密码</router-link></a-menu-item
          >
        </a-sub-menu>

        <a-sub-menu key="sub1">
          <template #icon>
            <laptop-outlined :style="{ fontSize: '16px' }" />
          </template>
          <template #title>权限中心</template>
          <a-menu-item key="/user"
            ><router-link to="/user">系统用户管理</router-link></a-menu-item
          >
          <a-menu-item key="/module"
            ><router-link to="/module">模块管理</router-link></a-menu-item
          >
          <a-menu-item key="/userModulePower"
            ><router-link to="/userModulePower"
              >用户模块权限管理</router-link
            ></a-menu-item
          >
        </a-sub-menu>

        <a-sub-menu key="sub2">
          <template #icon>
            <laptop-outlined :style="{ fontSize: '16px' }" />
          </template>
          <template #title>全局管理</template>
          <a-menu-item key="/goods"
            ><router-link to="/goods">全局商品</router-link></a-menu-item
          >
          <a-menu-item key="/goodsClassification"
            ><router-link to="/goodsClassification"
              >全局商品分类</router-link
            ></a-menu-item
          >
          <a-menu-item key="/enterpriseAccount"
            ><router-link to="/enterpriseAccount"
              >企业账户管理</router-link
            ></a-menu-item
          >
          <a-menu-item key="/costItem"
            ><router-link to="/costItem">全局费用项目</router-link></a-menu-item
          >
          <a-menu-item key="/area"
            ><router-link to="/area">行政区域</router-link></a-menu-item
          >
          <a-menu-item key="/smsSetting"
            ><router-link to="/smsSetting"
              >手机短信模板</router-link
            ></a-menu-item
          >
          <a-menu-item key="/setting"
            ><router-link to="/setting">系统参数设置</router-link></a-menu-item
          >
        </a-sub-menu>

        <a-sub-menu key="sub4">
          <template #icon>
            <laptop-outlined :style="{ fontSize: '16px' }" />
          </template>
          <template #title>企业管理</template>
          <a-menu-item key="/enterpriseCenter"
            ><router-link to="/enterpriseCenter"
              >企业管理中心</router-link
            ></a-menu-item
          >
          <a-menu-item key="/enterpriseGoods"
            ><router-link to="/enterpriseGoods"
              >企业商品库</router-link
            ></a-menu-item
          >
          <a-menu-item key="/enterpriseGoodsPriceControl"
            ><router-link to="/enterpriseGoodsPriceControl"
              >企业商品控价</router-link
            ></a-menu-item
          >

          <a-menu-item key="/officialAccountSetting"
            ><router-link to="/officialAccountSetting"
              >公众号管理</router-link
            ></a-menu-item
          >
        </a-sub-menu>

        <a-sub-menu key="sub5">
          <template #icon>
            <laptop-outlined :style="{ fontSize: '16px' }" />
          </template>
          <template #title>站点管理</template>
          <a-menu-item key="/siteCenter"
            ><router-link to="/siteCenter"
              >站点管理中心</router-link
            ></a-menu-item
          >
          <a-menu-item key="/siteGoods"
            ><router-link to="/siteGoods">商品管理</router-link></a-menu-item
          >
          <a-menu-item key="/siteMemberClassification"
            ><router-link to="/siteMemberClassification"
              >会员分类</router-link
            ></a-menu-item
          >
          <a-menu-item key="/siteMember"
            ><router-link to="/siteMember">会员管理</router-link></a-menu-item
          >
          <a-menu-item key="/siteGoodsMemberPrice"
            ><router-link to="/siteGoodsMemberPrice"
              >商品会员分类价</router-link
            ></a-menu-item
          >
          <a-menu-item key="/siteGoodsMemberExclusivePrice"
            ><router-link to="/siteGoodsMemberExclusivePrice"
              >商品会员专享价</router-link
            ></a-menu-item
          >
        </a-sub-menu>

        <a-sub-menu key="sub7">
          <template #icon>
            <laptop-outlined :style="{ fontSize: '16px' }" />
          </template>
          <template #title>销售</template>
          <a-menu-item key="/pointOfSale"
            ><router-link to="/pointOfSale">门店收银</router-link></a-menu-item
          >
          <a-menu-item key="/openOrder"
            ><router-link to="/openOrder">人工开单</router-link></a-menu-item
          >
          <a-menu-item key="/siteUnpayOrder"
            ><router-link to="/siteUnpayOrder"
              >待付款订单</router-link
            ></a-menu-item
          >
          <a-menu-item key="/siteOrderAwaitingShipment"
            ><router-link to="/siteOrderAwaitingShipment"
              >订单出库</router-link
            ></a-menu-item
          >
          <a-menu-item key="/siteSaleEvent"
            ><router-link to="/siteSaleEvent"
              >促销活动</router-link
            ></a-menu-item
          >
          <a-menu-item key="/siteCoupon"
            ><router-link to="/siteCoupon">优惠券管理</router-link></a-menu-item
          >
        </a-sub-menu>

        <a-sub-menu key="sub6">
          <template #icon>
            <laptop-outlined :style="{ fontSize: '16px' }" />
          </template>
          <template #title>库存</template>
          <a-menu-item key="/stockQuery"
            ><router-link to="/stockQuery">库存查询</router-link></a-menu-item
          >
          <a-menu-item key="/stockInput"
            ><router-link to="/stockInput">入库管理</router-link></a-menu-item
          >
          <a-menu-item key="/stockWarning"
            ><router-link to="/stockWarning"
              >库存预警设置</router-link
            ></a-menu-item
          >
          <a-menu-item key="/stockMoneyDetail"
            ><router-link to="/stockMoneyDetail"
              >库存资金明细</router-link
            ></a-menu-item
          >
        </a-sub-menu>

        <a-sub-menu key="sub8">
          <template #icon>
            <laptop-outlined :style="{ fontSize: '16px' }" />
          </template>
          <template #title>财务</template>
          <a-menu-item key="/financeBookkeeping"
            ><router-link to="/financeBookkeeping"
              >费用记账</router-link
            ></a-menu-item
          >
          <a-menu-item key="/financeDeposit"
            ><router-link to="/financeDeposit"
              >押金管理</router-link
            ></a-menu-item
          >
        </a-sub-menu>

        <a-sub-menu key="sub9">
          <template #icon>
            <laptop-outlined :style="{ fontSize: '16px' }" />
          </template>
          <template #title>报表管理</template>
        </a-sub-menu>

        <a-sub-menu key="sub10">
          <template #icon>
            <laptop-outlined :style="{ fontSize: '16px' }" />
          </template>
          <template #title>门户中心</template>
        </a-sub-menu>
      </a-menu>
    </a-layout-header>

    <a-layout>
      <a-layout-sider theme="light" class="sider">
        <a-list size="large">
          <a-list-item
            ><router-link to="/home"
              ><home-two-tone />首页</router-link
            ></a-list-item
          >
          <a-list-item
            ><a href="javascript:void(0)" @click="logout"
              ><logout-outlined />退出
            </a></a-list-item
          >
          <template #header>
            <div align="center">
              <h4 class="j-fw">
                <img src="@/assets/logo.png" width="40px" height="40px" />
                <br />
                {{ inject("appname") }}
              </h4>
              <h5 class="j-text-primary j-fw">{{ today }}</h5>
              <a-tag color="purple">{{ inject("version") }}</a-tag>
            </div>
          </template>
        </a-list>
        <!--        <div class="version">-->
        <!--          <h5>V3.0.0.202305.beta</h5>-->
        <!--        </div>-->
      </a-layout-sider>
      <a-layout-content style="padding: 20px" class="main-content">
        <router-view />
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script setup>
import {
  //SettingOutlined,
  HomeTwoTone,
  LogoutOutlined,
} from "@ant-design/icons-vue";

import router from "@/router";
import jaxios from "@/request/http";
import { message } from "ant-design-vue";
import { onMounted, reactive, ref, inject } from "vue";
import dayjs from "dayjs";

/*
import { useRouter } from "vue-router";

const handelClick = (item) => {
  const router = useRouter();
  if (item.key !== router.path) {
    router.push(item.key);
  }
};
 */
const today = ref(dayjs().format("YYYY-MM-DD dddd HH:mm:ss"));

const loginData = reactive({
  name: "",
  username: "",
});

const logout = () => {
  router.push("/login");
  jaxios
    .post("/login/logout")
    .then((response) => {
      if (response.data.code == 200) {
        message.success("登出成功！");
        localStorage.removeItem("token");
        router.push("/login");
      }
    })
    .catch((error) => {
      console.log(error);
      message.error("登出失败！");
    });
};

onMounted(() => {
  loginData.name = "未登入";
  let _name = localStorage.getItem("name");
  if (_name != null) {
    loginData.name = _name;
  }

  let _username = localStorage.getItem("username");
  loginData.username = "-";
  if (_username != null) {
    loginData.username = _username;
  }

  setInterval(function () {
    today.value = dayjs().format("YYYY-MM-DD dddd HH:mm:ss");
  }, 1000);
});
</script>

<style scoped lang="scss">
#root,
body,
html {
  height: 100%;
}

.icon-size {
  font-size: 25px;
}

.ant-layout {
  display: flex;
  width: 100%;
  min-height: 100%;
}

.version {
  font-size: 16px;
  position: absolute;
  bottom: 0px;
  text-align: center;
  width: 100%;
  line-height: 40px;
}
.main-header {
  padding: 0px;
}

.main-content {
  background-image: url("../assets/main-content-bg.png") !important;
  background-repeat: no-repeat; /* 水平方向平铺（关键） */
  background-size: 100% 300px; /* 宽度100%铺满，高度按原图比例自适应 */
  background-position: right bottom -119px; /* 靠底部显示（关键） */
  background-attachment: local; /* 确保滚动时背景跟随容器，不固定 */
  min-height: calc(100vh - 69px); /* 保证容器占满视口高度，背景能显示完整 */
  height: 100%;
}

.menu {
  background-color: #5330b0;
  color: #fff;
  a {
    text-decoration: none;
  }
  a:link {
    color: #000000;
  }
  a:visited {
    color: #fff;
  }
  a:hover {
    color: #fff;
  }
  a:active {
    color: #666;
  }
}
</style>
